import React, { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";
import { apiCall } from "../Components/util";

const DataContext = createContext();

export const DataProvider = ({ children }) => {
  const [data, setData] = useState(() => {
    // Load from localStorage first
    const cachedData = localStorage.getItem("settingsData");
    try {
      return cachedData ? JSON.parse(cachedData) : {}; // Use empty object instead of null
    } catch (error) {
      console.error("Error parsing cached data:", error);
      return {}; // Return an empty object if parsing fails
    }
  });

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.post(apiCall + "generalsettings/getall");
        setData(response.data[0]); // Update state
        localStorage.setItem("settingsData", JSON.stringify(response.data[0])); // Store in localStorage
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData(); // Always fetch fresh data when the browser is opened
  }, []); // Runs only once when the component mounts

  return <DataContext.Provider value={data}>{children}</DataContext.Provider>;
};

export const useData = () => useContext(DataContext);











// import React, { createContext, useContext, useEffect, useState } from "react";
// import axios from "axios";
// import { apiCall } from "../Components/util";

// const DataContext = createContext();

// export const DataProvider = ({ children }) => {
//   const [data, setData] = useState(() => {
//     // Load from localStorage first
//     const cachedData = localStorage.getItem("settingsData");
//     return cachedData ? JSON.parse(cachedData) : {}; // Use empty object instead of null
//   });

//   useEffect(() => {
//     const fetchData = async () => {
//       try {
//         const response = await axios.post(apiCall + "generalsettings/getall");
//         setData(response.data[0]); // Update state
//         localStorage.setItem("settingsData", JSON.stringify(response.data[0])); // Store in localStorage
//       } catch (error) {
//         console.error("Error fetching data:", error);
//       }
//     };

//     fetchData(); // Always fetch fresh data when the browser is opened
//   }, []); // Runs only once when the component mounts

//   return <DataContext.Provider value={data}>{children}</DataContext.Provider>;
// };

// export const useData = () => useContext(DataContext);
